<template lang="html">
  <div>
    <!--    <div class="section-container">
          <div class="text-to-left">
            <div>
              <h2>UniStart</h2>
              <p>Exclusive event for high achieving school-leavers of Black heritage who are about to start at university this
                year. If you are accepted, you will be considered for Rare’s development programmes for ethnic minority and
                social mobility candidates.</p>
              <div class="button-container">
                <rare-standard-button
                  class="contactButton show-for-small-only"
                  :tabindex="12"
                  :active="'true'"
                  :buttonText="'Apply to unistart'"
                  :height="'40px'"
                  :width="'240px'"
                  :fontColor="'#ffffff'"
                  :fontSize="'14px'"
                  @clicked="handleButtonClick('https://apply.candidx.io/95470ef1-6093-489a-bc0a-32f571d7cd67')"
                />
                <rare-standard-button
                  class="contactButton show-for-medium"
                  :tabindex="12"
                  :active="'true'"
                  :buttonText="'Apply to unistart'"
                  :height="'70px'"
                  :width="'370px'"
                  :fontColor="'#ffffff'"
                  :fontSize="'20px'"
                  @clicked="handleButtonClick('https://apply.candidx.io/95470ef1-6093-489a-bc0a-32f571d7cd67')"
                />
              </div>
            </div>
          </div>
          <div class="image-right chart">
            &nbsp;
          </div>
        </div>-->

    <div class="section-container">
      <div class="text-to-left">
        <div>
          <h2>Commercial Law</h2>
          <p><b>For applicants interested in applying to Commercial Law firms this year.</b></p>
          <p>If you are accepted, Rare will
            support you with your applications and interviews with our clients. Eligible candidates may also be
            contacted about Rare’s development programmes.</p>
          <div class="button-container">
            <rare-standard-button
              class="contactButton show-for-small-only"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Apply now'"
              :height="'40px'"
              :width="'240px'"
              :fontColor="'#ffffff'"
              :fontSize="'14px'"
              @clicked="handleButtonClick('https://apply.candidx.io/aa87e160-ab5b-4bda-be28-3651d82e8e4c')"
            />
            <rare-standard-button
              class="contactButton show-for-medium"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Apply now'"
              :height="'70px'"
              :width="'370px'"
              :fontColor="'#ffffff'"
              :fontSize="'20px'"
              @clicked="handleButtonClick('https://apply.candidx.io/aa87e160-ab5b-4bda-be28-3651d82e8e4c')"
            />
          </div>
        </div>
      </div>
      <div class="image-right chart">
        &nbsp;
      </div>
    </div>
    <div class="section-container reverse-for-small">
      <div class="image-left brain">
        &nbsp;
      </div>
      <div class="text-to-right">
        <div>
          <h2>Invessed</h2>
          <p><b>Receive expert advice for careers in business, finance & consulting.</b></p>
          <p>Sign up for regular email updates about making the best possible applications and nailing your interviews,
            plus employer job and internship alerts. Eligible candidates may also be contacted about Rare’s development
            programmes.</p>
          <div class="button-container">
            <rare-standard-button
              class="contactButton show-for-small-only"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Sign up for Invessed'"
              :height="'40px'"
              :width="'240px'"
              :fontColor="'#ffffff'"
              :fontSize="'14px'"
              @clicked="handleButtonClick('https://invessed.careers/')"
            />
            <rare-standard-button
              class="contactButton show-for-medium"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Sign up for Invessed'"
              :height="'70px'"
              :width="'370px'"
              :fontColor="'#ffffff'"
              :fontSize="'20px'"
              @clicked="handleButtonClick('https://invessed.careers/')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
        <div>
          <h2>Vantage</h2>
          <p><b>Connect with elite legal employers.</b></p>
          <p>Sign up to hear directly from employers about work experience, vacation schemes, mini pupillages,
            training contracts, pupillages, insight events and more.</p>

          <div class="button-container">
            <rare-standard-button
              class="contactButton show-for-small-only"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Sign up for vantage'"
              :height="'40px'"
              :width="'240px'"
              :fontColor="'#ffffff'"
              :fontSize="'14px'"
              @clicked="handleButtonClick('https://www.vantageapp.io/')"
            />
            <rare-standard-button
              class="contactButton show-for-medium"
              :tabindex="12"
              :active="'true'"
              :buttonText="'Sign up for vantage'"
              :height="'70px'"
              :width="'370px'"
              :fontColor="'#ffffff'"
              :fontSize="'20px'"
              @clicked="handleButtonClick('https://www.vantageapp.io/')"
            />
          </div>
        </div>
      </div>
      <div class="image-right interview">
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'ApplyNowMainSection',
  props: {
  },
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    handleButtonClick(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
}

.section-container {
  display: flex;
  min-height: 610px;
  justify-content: space-between;
}

.text-to-left, .text-to-right, .text-to-left-59 {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  width: 58%;
  padding: 0 10%;
}

.text-to-left-59 {
  width: 59%;
}

.text-to-left h2, .text-to-left-59 h2, .text-to-right h2 {
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
}

.text-to-left p, .text-to-left-59 p, .text-to-right p {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  margin: 20px 0 20px 0;
}

.button-container {
  margin: 70px 0 50px 0;
}

.text-to-left, .text-to-left-59, .text-to-right {
  background-color: #ffffff;
  color: $main-text
}

.image-left, .image-right {
  background-position: center center;
  background-size: cover;
  width: 610px;
  height: 610px;
}

@media only screen and (max-width: 800px) {
  .section-container {
    flex-direction: column;
    min-height: 400px;
  }

  .reverse-for-small {
    flex-direction: column-reverse !important;
  }

  .text-to-left, .text-to-right, text-to-left-59 {
    width: 100%;
    padding: 0 20px;
  }

  .text-to-left h2, .text-to-right h2, text-to-left-59 h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.39;
    margin: 32px 0 0 0;
    text-align: center;
  }

  .text-to-left p, .text-to-right p, text-to-left-59 p {
    font-size: 18px;
    line-height: 1.43;
    letter-spacing: normal;
    margin: 10px 0 20px 0;
    text-align: center;
  }

  .image-left, .image-right {
    width: 100%;
    height: 400px;
  }

  .button-container {
    margin: 30px 0 50px 0;
    display: flex;
    justify-content: center;
  }


}

@media only screen and (min-width: 800px) {
  .text-to-left p:last-of-type, .text-to-left-59 p:last-of-type, .text-to-right p:last-of-type {
    margin-bottom: 0;
  }
}

.chart {
  background-image: url('../../../assets/img/applyNow/unistart.png');
}

.brain {
  background-image: url('../../../assets/img/applyNow/invessed.png');
}

.interview {
  background-image: url('../../../assets/img/applyNow/vantage.png');
}
</style>



// WEBPACK FOOTER //
// src/pages/applyNow/components/ApplyNowMainSection.vue